// extracted by mini-css-extract-plugin
module.exports = {"notice":"style_notice__3jEdU","icon":"style_icon__3G6MO","body":"style_body__37PeS","title":"style_title__3wysN","text":"style_text__36Gn2","cta":"style_cta__2TF_4"};